import { Badge, Button, Col, DatePicker, Dropdown, Row, Select } from "antd";
import { Field, Form, Formik } from "formik";
import React, { FC, useEffect, useState } from "react";
import FilterIcon from "../../../assets/icons/filter-icon-filled.svg";
import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import CalendarIcon from "../../../assets/icons/calendar-primary.svg";
import CommonService from "../../../services/CommonService/common.service";
import { deserialize } from "serializr";
import moment from "moment";

import AuthContainer from "../../../store/container/AuthContainer";
import { DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";

const { RangePicker } = DatePicker;
interface DashboardLoginReportFilterProps {
  applyHandler: (values: DashboardFilterModel) => void;
  clearHandler: () => void,
  user: any;
}

const DashboardLoginReportFilter: FC<DashboardLoginReportFilterProps> = (props) => {
  const {
    applyHandler,
    clearHandler,
    user
  } = props;

  const [initialValues, setInitialValues] = useState<DashboardFilterModel>({});
  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [institutes, setInstitutes] = useState<MetaModel[]>([]);
  const [classRooms, setClassRooms] = useState<MetaModel[]>([]);
  const [branches, setBranches] = useState<MetaModel[]>([]);
  const [sections, setSections] = useState<MetaModel[]>([]);
  const [open, setOpen] = useState<boolean>(false);

  const fetchBoards = () => {
    CommonService.fetchBoardsMeta(
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBoards(meta);

        if (user?.roleName === "instituteadmin") {
            setInitialValues({ board: Number(meta[0].value) })
            fetchInstitutes()
          }
      },
      () => { },
      () => { }
    );
  };

  const fetchInstitutes = () => {
    CommonService.fetchInstitutesMeta(
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setInstitutes(meta);
        if (user?.roleName === "instituteadmin") {
            let value = Number(meta[0].value)
            setInitialValues((prevState) => { return { ...prevState, institute: value } })
            fetchBranches(value)
          }
      },
      () => { },
      () => { }
    );
  };

  const fetchBranches = (id: number) => {
    CommonService.fetchBranchesMeta(
      id,
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBranches(meta);
        // if (meta.length && open === false) {
        //   let value = Number(meta[0].value)
        //   setInitialValues((prevState) => { return { ...prevState, branch: value } })
        // }
      },
      () => { },
      () => { }
    );
  };

  const fetchGrades = (branchId: number) => {
    CommonService.fetchGradeMeta(
      branchId,
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setClassRooms(meta);
      },
      () => { },
      () => { }
    );
  };

  const fetchSections = (branchId: number, classId: number) => {
    CommonService.fetchSectionsMeta(
      { ClassId: classId, BranchId: branchId },
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setSections(response);
      },
      () => { },
      () => { }
    );
  };

  useEffect(() => {
    fetchBoards();
  }, []);

  const fetchCount = () => {
    let count = 0;
    if (initialValues?.lastLoginStartingDate) count += 1;
    if (initialValues?.board) count += 1;
    if (initialValues?.institute) count += 1;
    if (initialValues?.branch) count += 1;
    if (initialValues?.classRoom) count += 1;
    if (initialValues?.section) count += 1;
    if (initialValues?.loggedIn !== undefined) count += 1;
    return count;
  };

  return (
    <Formik initialValues={initialValues} onSubmit={() => { }} enableReinitialize>
      {({ values, setFieldValue, resetForm }) => (
        <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <Dropdown
            overlayClassName="dashboard-filter__overlay"
            className="dashboard-filter"
            trigger={["click"]}
            onOpenChange={(open: boolean) => setOpen(open)}
            open={open}
            overlay={
              <div className="dashboard-filter-form__wrapper">
                <div
                  className='dashboard-filter-form__field'
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Date Range</label>
                  <Field
                    name='lastLoginDate'
                    as={RangePicker}
                    value={[
                      values?.lastLoginStartingDate
                        ? moment(values?.lastLoginStartingDate, 'YYYY-MM-DD')
                        : undefined,
                      values?.lastLoginEndingDate
                        ? moment(values?.lastLoginEndingDate, 'YYYY-MM-DD')
                        : undefined,
                    ]}
                    onChange={(dates) => {
                      if (dates?.length) {
                        setFieldValue(
                          'lastLoginStartingDate',
                          moment(dates?.[0])?.format('YYYY-MM-DD')
                        );
                        setFieldValue(
                          'lastLoginEndingDate',
                          moment(dates?.[1])?.format('YYYY-MM-DD')
                        );
                      } else {
                        setFieldValue('lastLoginStartingDate', 0);
                        setFieldValue('lastLoginEndingDate', 0);
                      }
                    }}
                    suffixIcon={
                      <img
                        className='calendar__icon'
                        src={CalendarIcon}
                        alt='Calender'
                      />
                    }
                  />
                </div>
                                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Board</label>
                  <Field
                    disabled={user?.roleName === "instituteadmin" ? true : false}
                    as={Select}
                    name="board"
                    placeholder="Select Board"
                    options={boards}
                    value={values?.board}
                    onChange={(value) => {
                      setFieldValue("board", value);
                      fetchInstitutes()
                    }}
                  />
                </div>

                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Institutes</label>
                  <Field
                    disabled={user?.roleName === "instituteadmin" ? true : false}
                    as={Select}
                    name="institutes"
                    placeholder="Select Institutes"
                    options={institutes}
                    value={values?.institute}
                    onChange={(value) => {
                      setFieldValue("institute", value);
                      fetchBranches(value)
                    }}
                  />
                </div>
                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                <label>School</label>
                <Field
                  as={Select}
                  name="school"
                  placeholder="Select School"
                  options={branches}
                  value={values?.branch}
                  onChange={(value) => {
                    setFieldValue("branch", value);
                    fetchGrades(value)
                  }}
                />
              </div>
              <div className="dashboard-filter-form__wrapper">
                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Class</label>
                  <Field
                    as={Select}
                    name="classRoom"
                    placeholder="Select Class"
                    options={classRooms}
                    value={values?.classRoom}
                    onChange={(value) => {
                      setFieldValue("classRoom", value);
                      values?.branch &&
                      fetchSections(values?.branch, value)
                    }}
                  />
                </div>
              </div>
              <div className="dashboard-filter-form__wrapper">
                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Section</label>
                  <Field
                    as={Select}
                    name="section"
                    placeholder="Select Section"
                    options={sections}
                    value={values?.section}
                    onChange={(value) => {
                      setFieldValue("section", value);
                    }}
                  />
                </div>
              </div>
              <div className="dashboard-filter-form__wrapper">
                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Logged In</label>
                  <Field
                    as={Select}
                    name="loggedIn"
                    placeholder="Select Option"
                    options={[
                      { value: true, label: 'Yes' },
                      { value: false, label: 'No' }
                    ]}
                    value={values?.loggedIn}
                    onChange={(value) => {
                      setFieldValue("loggedIn", value);
                    }}
                  />
                </div>
              </div>
                <Row gutter={12} className="dashboard-filter__controllers">
                  <Col span={12}>
                    <Button
                      type="default"
                      onClick={() => {
                        resetForm({});
                        setInitialValues({})
                        clearHandler()
                      }}
                    >
                      Clear Filters
                    </Button>

                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      onClick={() => {
                        resetForm({ values });
                        setInitialValues(values);
                        applyHandler(values);
                        setOpen(false);
                      }}
                    >
                      Apply Filters
                    </Button>
                  </Col>
                </Row>
              </div>
            }
          >
            <Badge count={fetchCount()}>
              <div className="filter__icon">
                <img src={FilterIcon} alt="Fliter" />
              </div>
            </Badge>
          </Dropdown>
        </Form>
      )}
    </Formik>
  );
};

export default AuthContainer(DashboardLoginReportFilter);
